import { Button, CircularProgress, Grid2 } from "@mui/material";
import React from "react";

interface ConfirmCancelActionsV2Props {
	confirmLabel: string;
	onConfirm: () => void;
	onCancel: () => void;
	isBusy?: boolean;
	disabled?: boolean;
	confirmColor?: "primary" | "secondary";
	cancelLabel?: string;
}

export const ConfirmCancelActionsV2 = ({
	confirmLabel,
	onConfirm,
	onCancel,
	isBusy = false,
	disabled = false,
	confirmColor = "primary",
	cancelLabel = "Cancel",
}: ConfirmCancelActionsV2Props) => {
	return (
		<Grid2 container spacing={2} justifyContent="flex-end">
			<Grid2 size={{ md: 3, xs: 12 }}>
				<Button
					fullWidth
					variant="contained"
					color="inherit"
					onClick={onCancel}
					disabled={isBusy}
				>
					{cancelLabel}
				</Button>
			</Grid2>
			<Grid2 size={{ md: 3, xs: 12 }}>
				<Button
					fullWidth
					startIcon={isBusy && <CircularProgress size="1rem" />}
					disabled={isBusy || disabled}
					variant="contained"
					color={confirmColor}
					onClick={onConfirm}
				>
					{confirmLabel}
				</Button>
			</Grid2>
		</Grid2>
	);
};
